import { useEffect, useState } from 'react';
import { APIS } from '../../constants/apis';
import { fetchAPI } from '../../utils/fetchAPI';
import { useAuth } from '../useAuth/useAuth';

export const useVideoData = () => {
  const { user } = useAuth();
  const [videos, setVideos] = useState();
  const [isVideosLoading, setIsVideosLoading] = useState(true);

  if (process.env.REACT_APP_LOCAL_DEV === 'true') {
    jwt = 'secure_token';
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const videos = await fetchAPI({
          url: APIS.getVideos,
          method: 'GET',
          header: {
            Authorization: `Bearer ${user?.jwt}`,
          },
        });

        setVideos(videos);
        setIsVideosLoading(false);
      } catch (err) {
        throw new Error(err.message);
      }
    };

    if (user?.jwt) {
      getData();
    }
  }, [user]);

  return { videos, isVideosLoading };
};
